import { call, put } from 'redux-saga/effects';
import { ProductTypes as Types } from '../ducks/product';
import { sagaErrorHandle } from './sagasError';
import { fetchConfig } from '../../services/product';
import AppMemoryCookies from '../../utils/handleCookies';

export function* getConfig() {
  try {
    const ret = yield call(fetchConfig);
    const { product } = ret.config.headers;
    const productConfigs = ret.data;
    if (ret.data) {
      yield put({
        type: Types.SET_CONFIG,
        config: { ...productConfigs, product },
      });
    } else {
      const memoryCookie = AppMemoryCookies.getSession();

      if (memoryCookie) {
        yield put({
          type: Types.SET_PRODUCT_ERROR,
          error: 'Ocorreu um erro ao obter os dados da página.',
          product,
        });
      }
    }
  } catch (error) {
    yield sagaErrorHandle({
      sagaName: 'getConfig',
      errorData: error,
    });
  }
}
